// extracted by mini-css-extract-plugin
module.exports = {"boardUsers":"BoardUsers_boardUsers__kESwa","users":"BoardUsers_users__3Vgdi","users__avatar":"BoardUsers_users__avatar__MVFH9"};